import { venueLabel } from './scope';
import type { VenueRows } from './useVenueRows';
import { useT } from '../i18n/useT';

/** "Show other venues" checkbox; renders nothing when the app is not venue-scoped. */
export default function OtherVenuesToggle({ v, hidden, className = '' }: { v: VenueRows; hidden: number; className?: string }) {
  const t = useT();
  if (!v.scoped) return null;
  return (
    <span className={`inline-flex flex-wrap items-center gap-x-2 text-xs text-muted ${className}`}>
      <label className="flex items-center gap-1.5">
        <input
          type="checkbox"
          aria-label={t('venue.show_other')}
          checked={v.showOther}
          onChange={(e) => v.setShowOther(e.target.checked)}
        />
        {t('venue.show_other')}
      </label>
      <span data-testid="venue-rows-note">
        {v.showOther
          ? t('venue.read_only')
          : hidden > 0
            ? t('venue.hidden', { n: hidden })
            : t('venue.current', { venue: venueLabel(v.venue) })}
      </span>
    </span>
  );
}
